import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { captureMarketingAttributionFromUrl } from "./config/MarketingAttribution";
// import { BrowserRouter } from "react-router-dom";
import { hydrate, render } from "react-dom";
const rootElement = document.getElementById("root");

captureMarketingAttributionFromUrl();

if (rootElement.hasChildNodes()) {

  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// ReactDOM.render(
//   // <React.StrictMode>
//     <BrowserRouter basename="">
//       <App />
//     </BrowserRouter>,
//   // </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
